import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, NgZone, Input, SimpleChanges } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetService } from '../../services/asset.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MapsService } from 'src/app/services/maps.service';
declare var $: any;

@Component({
  selector: 'app-inspection-from',
  templateUrl: './inspection-from.component.html',
  styleUrls: ['./inspection-from.component.scss']
})
export class InspectionFromComponent implements OnInit {



  loading
  isEdit: boolean
  isMapEdit: boolean
  isFirstForm: boolean
  files: any = [];
  newFiles: any = [];
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  map: google.maps.Map;
  bounds
  geoCoder
  assetId
  inspectionFormData = []
  selectedIndex
  selectedFormDetails

  inspectionForm: FormGroup
  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  previousIndex: any;
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  userId: any;
  currentUser: any;
  _isControlDisable = false
  _isEnableMap = true
  // firstChange: boolean = false;



  constructor(
    public dialog: MatDialog,
    public router: Router,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService,
  ) {

  }

  ngOnInit() {
    console.log('HELLO HERE IS EDIT MAPP', this.isEdit)
    // this.isMapEdit=false
    this.activatedRouter.params.subscribe(params => {
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
    })
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("this.currentUser", this.currentUser);
    console.log("this.inspectionFormData", this.inspectionFormData);
    // this.isMapEdit = false
    this.createForm()


  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Inspection form changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue && changes.documentDetails.currentValue.length) {
      let data = changes.documentDetails.currentValue
      console.log("data of documentDetails --->", data);
      // this.inspectionFormData = data

      let allFormList = data.filter((x) => x.userDocumentId.documentMetaId.title === 'inspectionForm')
      console.log("same for data for multiple forms", allFormList);
      if (allFormList && allFormList.length) {
        this.isEdit = true
        // this.isMapEdit = true
        this.inspectionFormData = allFormList
        this.selectedIndex = this.inspectionFormData[0]._id
        this.selectedFormDetails = this.inspectionFormData[0].userDocumentId
        this._isControlDisable = true
        this._isEnableMap = false
        this.changeFormData()
      }

    }

  }


  // FORMCONTROLL


  createForm(data?) {
    console.log("dataO45", data);
    this.inspectionForm = new FormGroup({
      onDate: new FormControl((data && data.onDate) ? data.onDate : ''),
      expiryDate: new FormControl((data && data.expiryDate) ? data.expiryDate : ''),
      workingOrder: new FormControl((data && data.workingOrder) ? data.workingOrder : ''),
      fleetType: new FormControl((data && data.fleetType) ? data.fleetType : ''),
      motDate: new FormControl((data && data.motDate) ? data.motDate : ''),
      taxDate: new FormControl((data && data.taxDate) ? data.taxDate : ''),
      serviceDate: new FormControl((data && data.serviceDate) ? data.serviceDate : ''),
      regPlate: new FormControl((data && data.regPlate) ? data.regPlate : ''),
      calibration: new FormControl((data && data.calibration) ? data.calibration : ''),
    })
  }



  // UTILITY

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);

    if (formControl == 'onDate') {
      this.inspectionForm.patchValue({ onDate: value })
    }
    else if (formControl == 'expiryDate') {
      this.inspectionForm.patchValue({ expiryDate: value })
    }
    else if (formControl == 'motDate') {
      this.inspectionForm.patchValue({ motDate: value })
    }
    else if (formControl == 'taxDate') {
      this.inspectionForm.patchValue({ taxDate: value })
    }
    else {
      this.inspectionForm.patchValue({ serviceDate: value })
    }

    // console.log('formgroup value', this.inspectionForm.value);
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  deleteFile(event) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(event, 1)
    console.log("after file removd", this.files);
  }
  deleteNewFile(event) {
    this.newFiles.splice(event, 1)
  }


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address

  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['inspectionForm'] = {}
    obj.userDocumentId['details'] = details
    this.inspectionFormData.push(obj)
    this.selectedIndex = this.inspectionFormData[this.inspectionFormData.length - 1]._id
    this.selectedFormDetails = this.inspectionFormData[this.inspectionFormData.length - 1].userDocumentId
    this._isEnableMap = true
    this._isControlDisable = false
    // this.inspectionFormData = []
    this.createForm(true)
    this.isEdit = false
    this.isMapEdit = false
    this.files = []
  }


  changeFormTab(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("inspectionFormData", this.inspectionFormData);
    console.log("index", index);
    this.selectedIndex = this.inspectionFormData[index]._id
    this.selectedFormDetails = this.inspectionFormData[index].userDocumentId
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
      this._isEnableMap = false
    } else {
      this._isControlDisable = false
      this._isEnableMap = true
    }
    this.changeFormData()
  }


  changeFormData() {
    console.log("this.selectedFormDetails", this.selectedFormDetails);
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.latitude = (this.selectedFormDetails.details.inspectionForm && this.selectedFormDetails.details.inspectionForm.location) ? this.selectedFormDetails.details.inspectionForm.location.coords.lat : ''
    this.longitude = (this.selectedFormDetails.details.inspectionForm && this.selectedFormDetails.details.inspectionForm.location) ? this.selectedFormDetails.details.inspectionForm.location.coords.lng : ''
    this.address = (this.selectedFormDetails.details.inspectionForm && this.selectedFormDetails.details.inspectionForm.location) ? this.selectedFormDetails.details.inspectionForm.location.address : ''
    this.inspectionForm.value['location'] = {
      coords: { lat: this.latitude, lng: this.longitude },
      address: this.address
    }
    // this.isEdit = true
    // this.isMapEdit = true
    this.createForm(this.selectedFormDetails.details.inspectionForm)
  }



  // API CALL


  onSubmit() {
    this.loading = true
    console.log("is edit ...", this.isEdit)
    if (this.inspectionForm.valid) {
      console.log('formgroup value', this.inspectionForm.value);
      console.log('file value', this.files);


      if (this.isEdit) {
        let obj = {
          metaObj: {
            title: 'inspectionForm',
          },
          documentId: this.selectedFormDetails.documentId,
          userId: this.userId,
          onModel: 'asset',
          documentMetaId: this.selectedFormDetails.documentMetaId,
          userDocumentId: this.selectedFormDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }

        this.inspectionForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        let details = {
          inspectionForm: this.inspectionForm.value
        }
        obj['details'] = details
        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      } else {

        let obj = {
          metaObj: {
            title: 'inspectionForm',
          },
          documentId: this.assetId,
          userId: this.userId,
          onModel: 'asset',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }
        this.inspectionForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        let details = {
          inspectionForm: this.inspectionForm.value
        }
        obj['details'] = details

        this._assetService.submitAssetForm(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
        // this._utilityService.handleSnackBar({ msg: "Inspection form submitted successfully!", button: "OK" })
      }
    }
    else {
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      this.loading = false
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  mapClicked(event) {

  }
}
